import Attachment from "./attachment";

export default class LiveChatMessage {
  readonly id: number
  readonly userName: string
  readonly userId: string
  readonly userAvatar: string
  readonly content: string
  readonly attachments: Attachment[]


  constructor(data: { [key: string]: any }) {
    this.id = data.id
    this.userName = data.userName
    this.userId = data.userId
    this.userAvatar = data.userAvatar
    this.content = data.content
    this.attachments = data.attachments
  }
}
